import * as React from "react";
export class WrapperShell extends React.Component {
    render() {
        return (this.props.isDesktop && this.props.autoLoopEnabled ?
            React.createElement("div", { className: "rj-superbanner__wrapper-shell", "data-uat": "wrapper-superbanner-shell", onMouseLeave: this.props.autoLoopStart, onMouseEnter: this.props.autoLoopStop }, this.props.children)
            :
                React.createElement("div", { className: "rj-superbanner__wrapper-shell", "data-uat": "wrapper-superbanner-shell" }, this.props.children));
    }
}
//# sourceMappingURL=WrapperShell.js.map